module.exports = __webpack_public_path__ + "static/13-a9418d223ed213bef8fbaab222df6c97.jpg";